
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import BookReference from '@/api/mjegb/BookReference';
import { Subscription } from 'rxjs';
import BookRepository from '@/api/BookRepository';
import GlobalState from '@/util/GlobalState';
import { BeforeDestroyAware } from '@/util/lifecycle';

@Component
export default class OpenDialog extends Vue implements BeforeDestroyAware {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly value!: boolean;

    public books: BookReference[] = [];
    public selection: number | null = null;
    public loading = true;

    @Inject() private readonly globalState!: GlobalState;
    @Inject() private readonly bookRepository!: BookRepository;
    private bookSubscription = new Subscription();

    public beforeDestroy(): void {
        this.bookSubscription.unsubscribe();
    }

    public onSelect(): void {
        if (this.selection !== null) {
            this.$emit('select', this.selection);
        }
        this.onClose();
    }

    public onClose(): void {
        this.$emit('input', false);
    }

    @Watch('value')
    public onValueChanged(): void {
        this.bookSubscription.unsubscribe();
        this.bookSubscription = this.bookRepository.findAll().subscribe((resource) => {
            this.loading = resource.isLoading;
            if (resource.hasData()) {
                this.books = resource.data;
                if (this.books.length > 0) {
                    this.selection = this.books[0].id;
                } else {
                    this.selection = null;
                }
            }
            if (resource.isError) {
                this.globalState.emitOnMessageBus({ text: this.$t('actions.onOpen.error').toString(), error: true });
            }
        });
    }
}
